export default __webpack_public_path__ + "static/media/December2010.c942d5bc.png";